import { Modal, Form, IFormContext } from 'rewire-ui';
import scheduleModel from './ScheduleModel';
import { IDuplicateShiftData } from './DuplicateShiftDialogModel';

export class DuplicateMultipleShiftsDialogModel extends Modal {
  form: Form;
  shiftData: IDuplicateShiftData[];

  constructor() {
    super('Duplicate Shift(s)');
    this.shiftData = [];

    this.form = Form.create((form: IFormContext) => ({
      numOfDuplicates: form.number({ allowNegative: false, format: '#' }).label('# Duplicates').validators('required').autoFocus(),
    }));

    this.action('cancel').action('save', this.submit, { variant: 'contained', type: 'submit' });
  }

  reset() {
    this.form.reset();
    this.shiftData = [];
  }

  load(shiftData: IDuplicateShiftData[]) {
    this.reset();

    this.shiftData = shiftData;
    this.form.value = {
      numOfDuplicates: 1,
    };
    this.open();
  }

  private save = async (): Promise<boolean> => {
    const numOfDuplicates = this.form.field.numOfDuplicates.value;

    if (await scheduleModel.duplicateShifts(this.shiftData, numOfDuplicates)) {
      return true;
    }
    return false;
  };

  submit = async () => {
    return await this.form.submitAsync(this.save);
  };
}

const duplicateMultipleShiftsDialogModel = new DuplicateMultipleShiftsDialogModel();
export default duplicateMultipleShiftsDialogModel;
